import type { PayloadAction } from '@reduxjs/toolkit';

import type { TOffer } from 'shared/types/TRankingService';

import { isMplPreApprovalOfferElement, updateOnlineGroupElements } from '../../lib';
import { selectOnlineGroup } from '../creditSelection.selectors';
import type { ScenarioState } from '../scenario.slice';

export const setMplOfferStatus = (
  state: ScenarioState,
  action: PayloadAction<{
    productId: string;
    bankId: string;
    loansStatus?: TOffer['loansStatus'];
  }>,
) => {
  const onlineGroup = selectOnlineGroup({ scenario: state });

  if (!onlineGroup || !onlineGroup.elements) {
    return;
  }

  const { loansStatus, bankId, productId } = action.payload;

  const elements = onlineGroup.elements.map((offer) => {
    if (!isMplPreApprovalOfferElement(offer)) {
      return offer;
    }
    if (offer.productId === productId) {
      return {
        ...offer,
        apiStatus: loansStatus,
      };
    }

    if (offer.organizationNewId === bankId) {
      return {
        ...offer,
        isAlreadySentFromSameBank: true,
      };
    }
    return offer;
  });

  updateOnlineGroupElements(state, elements);
};
